/**
 * Created by Ivan on 17.11.2025
 */

const RiddlesLevelMasteryVertical = cc.Node.extend({
    ctor: function (mission, {
        closeWindowCallback, windowView
    }) {
        this._super();
        this.mission = mission;
        this.closeWindowCallback = closeWindowCallback;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.resolution.getSceneSize());

        this.createBg();
        this.createFrame();
        this.createImage();

        ComponentMap.attach(this, new FullScreenComponent({ view: windowView }));

        this.createLayout();
        this.createFg();
        this.createDecoration();
        this.createTitle();
        this.createProgress();
        this.createHelpButton();
        this.createCloseButton();

        this.onResize();
    },

    onResize: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        this.setContentSize2(cleverapps.resolution.getSceneSize());

        const bgRect = cleverapps.resolution.getBgRect();
        this.bg.setContentSize2(bgRect);
        this.bg.setPosition(bgRect.x, bgRect.y);

        if (this.scroll) {
            this.updateScrollSize();
        }

        if (this.top) {
            const bgSize = cleverapps.resolution.getBgSize();
            this.top.setContentSize2(bgSize.width + styles.fg.top.paddingX, this.top.height);
            this.flashlightLeft.setAlignment(styles.decoration.flashlight.left);
            this.flashlightRight.setAlignment(styles.decoration.flashlight.right);
        }
    },

    updateScrollSize: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const timerTop = this.timer.y + this.timer.height / 2;
        const timerBottom = this.timer.y - this.timer.height / 2;
        const frameTop = this.frame.y + this.frame.height / 2;
        const topEdge = timerTop + (frameTop - this.image.height - styles.scroll.topPadding);
        const scrollHeight = topEdge - timerBottom;

        this.scroll.setContentSize(styles.stagesList.width, scrollHeight);
        this.scroll.setPosition(this.timer.x, timerBottom + scrollHeight / 2);
    },

    createFrame: function () {
        const frame = this.frame = new cc.Node();
        frame.setName("frame");
        frame.setAnchorPoint(0.5, 0.5);
        this.addChild(frame);
    },

    createBg: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;

        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.levelmastery_window.frames.background_png, cleverapps.styles.Window.Background.scale9);
        bg.setAnchorPoint(0, 0);
        bg.setContentSize2(cleverapps.resolution.getBgSize());
        this.addChild(bg, -1);

        const pattern = new cleverapps.Spine(bundles.levelmastery_window.jsons.background_pattern_json);
        pattern.setAnimation(0, "vertical", true);
        pattern.setAlignment(styles.pattern);
        this.addChild(pattern);
    },

    createCloseButton: function () {
        const closeButton = new CloseRoundButton({
            onClicked: this.closeWindowCallback,
            styles: cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI.closeButton
        });
        this.addChild(closeButton, 2);
    },

    createImage: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;

        const image = this.image = new cleverapps.Spine(bundles.levelmastery_window.jsons.head_picture_json);
        image.setAnimation(0, "animation", true);
        this.frame.addChild(image);
        image.setAlignment(styles.headPicture);
    },

    createTitle: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI.title;

        const titleBg = new cc.Scale9Sprite(bundles.levelmastery_window.frames.title_bg_png);
        titleBg.setContentSize2(styles.width, titleBg.height);
        this.addChild(titleBg);
        titleBg.setAlignment(styles);

        const text = this.title = cleverapps.UI.generateOnlyText(Messages.get("LevelMasteryWindow.Title"), cleverapps.styles.FONTS.RIDDLES_LEVEL_MASTERY_VERTICAL_TITLE_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.fitTo(titleBg.width * 0.8);
        text.setAlignment(styles.text);
        titleBg.addChild(text);
    },

    createFg: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const fg = new cc.Node();
        fg.setContentSize2(styles.fg);
        this.frame.addChild(fg);
        fg.setAlignment(styles.fg.position);

        const top = this.top = new cc.Scale9Sprite(bundles.levelmastery_window.frames.foreground_png);
        top.setContentSize2(cleverapps.resolution.getBgSize().width + styles.fg.top.paddingX, styles.fg.top.height);
        top.setAlignment(styles.fg.top);
        fg.addChild(top);

        return fg;
    },

    createLayout: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const rows = this.mission.logic.getStageRewards().map(this.createRow.bind(this));
        const list = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.stagesList.margin,
            padding: styles.stagesList.padding,
            reversed: true
        });

        const timer = this.timer = new Timer(this.mission.getTimeLeft(), () => {}, {
            timerBg: bundles.levelmastery_window.frames.timer_bg_vertical_png,
            timerIcon: bundles.levelmastery_window.frames.timer_icon_vertical_png,
            width: styles.timer.width,
            font: cleverapps.styles.FONTS.RIDDLES_LEVEL_MASTERY_VERTICAL_TIMER_TEXT
        });
        this.addChild(timer, 1);
        timer.setAlignment(styles.timer);

        const scroll = this.scroll = new cleverapps.UI.ScrollView(list, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL,
            childrenVisibility: false
        });
        this.addChild(scroll, 0);

        this.updateScrollSize();
        scroll.scrollTo(rows[this.mission.logic.stage]);
    },

    createRow: function (reward, stage) {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const circle = this.createCircle(stage);
        const rewardCard = this.createRewardCard(reward, stage);

        return new cleverapps.Layout([circle, rewardCard], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.stageRow.margin,
            padding: styles.stageRow.padding
        });
    },

    createCircle: function (stage) {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const isCompleted = this.mission.logic.isCompleted(stage);
        const isCurrent = this.mission.logic.isCurrent(stage);
        const isLast = this.mission.logic.isLastStage(stage);
        const isLocked = !isCurrent && !isCompleted;

        const circle = new cc.Node();
        circle.setAnchorPoint(0.5, 0.5);

        const circleBg = new cc.Sprite(bundles.levelmastery.frames.circle_bg);
        circle.setContentSize(circleBg.getContentSize());
        circleBg.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(circleBg);

        const circleColored = new cc.Sprite(isCompleted ? bundles.levelmastery.frames.circle_green : bundles.levelmastery.frames.circle_blue);
        circleColored.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(circleColored);

        const stageNumber = cleverapps.UI.generateImageText(stage + 1, cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_VERTICAL_STAGE_TEXT);
        stageNumber.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(stageNumber);

        if (isCurrent) {
            StandartAnimations.rays(circle, { skin: "white" });
        }

        if (!isLast) {
            const line = cleverapps.UI.createScale9Sprite(bundles.levelmastery.frames.line);
            line.setLocalZOrder(-1);
            line.setAnchorPoint(0.5, 0);
            line.setContentSize(styles.stageRow.circle.line);
            line.setAlignment(styles.stageRow.circle.line);
            circle.addChild(line);
        }

        if (isLocked) {
            circleBg.setScale(0.8);
            circleColored.setScale(0.8);
            stageNumber.setScale(0.8);
        }

        return circle;
    },

    createRewardCard: function (reward, stage) {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const isCompleted = this.mission.logic.isCompleted(stage);
        const isCurrent = this.mission.logic.isCurrent(stage);
        const isLocked = !isCurrent && !isCompleted;

        const card = cleverapps.UI.createScale9Sprite(isCompleted ? bundles.levelmastery.frames.card_bg_white : bundles.levelmastery.frames.card_bg);
        card.setContentSize(styles.stageRow.card);

        const icon = isCompleted ? new cc.Sprite(bundles.levelmastery.frames.card_mark) : new RiddlesLevelMasteryRewardView(reward);
        icon.setAlignment(styles.stageRow.card.icon);
        cleverapps.UI.fitToBox(icon, styles.stageRow.card.icon);
        card.addChild(icon);

        if (isLocked) {
            const lock = new cc.Sprite(bundles.levelmastery.frames.card_lock);
            lock.setAlignment(styles.stageRow.card.lock);
            card.addChild(lock);
        }

        return card;
    },

    createDecoration: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI.decoration;

        const decorationLeft = new cc.Sprite(bundles.levelmastery_window.frames.crystals_decor_png);
        this.addChild(decorationLeft);
        decorationLeft.setAlignment(styles.crystals.left);

        const decorationRight = new cc.Sprite(bundles.levelmastery_window.frames.crystals_decor_png);
        this.addChild(decorationRight);
        decorationRight.setScaleX(-1);
        decorationRight.setAlignment(styles.crystals.right);

        const flashlightLeft = this.flashlightLeft = new cc.Sprite(bundles.levelmastery_window.frames.flashlight_png);
        this.top.addChild(flashlightLeft, -1);
        flashlightLeft.setAlignment(styles.flashlight.left);

        const flashlightRight = this.flashlightRight = new cc.Sprite(bundles.levelmastery_window.frames.flashlight_png);
        this.top.addChild(flashlightRight, -1);
        flashlightRight.setAlignment(styles.flashlight.right);
    },

    createProgress: function () {
        const styles = cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI;
        const progressBar = new RiddlesLevelMasteryWindowComponent(this.mission.logic, styles.windowComponent);
        this.frame.addChild(progressBar, 15);
        progressBar.setAlignment(styles.progressBar);
        progressBar.cupIcon.setScale(0.7);
        progressBar.rewardIcon.setScale(0.7);
    },

    createHelpButton: function () {
        const helpButton = new cleverapps.UI.HelpButton({
            type: {
                button_png: bundles.levelmastery_window.frames.help_button_png,
                button_on_png: bundles.levelmastery_window.frames.help_button_on_png
            },
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.mission);
            }
        });
        helpButton.setAnchorPoint(0.5, 0.5);
        this.addChild(helpButton, 10);
        helpButton.setAlignment(cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI.helpButton);
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    LEVEL_MASTERY_TITLE_STROKE: new cc.Color(194, 0, 34, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_LEVEL_MASTERY_VERTICAL_TITLE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LEVEL_MASTERY_TITLE_STROKE
    },

    RIDDLES_LEVEL_MASTERY_VERTICAL_TIMER_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    RIDDLES_LEVELMASTERY_VERTICAL_STAGE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },
    RIDDLES_LEVELMASTERY_WINDOW_TIMER_TEXT: {
        name: "nostroke",
        size: 38,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.LevelMasteryWindowVerticalRiddlesUI = {
    scroll: {
        topPadding: 95
    },

    title: {
        x: { align: "center" },
        y: { align: "top", dy: -20 },
        width: 360,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 15 }
        }
    },

    closeButton: {
        scale: [0.7, 0.7, 0.7],
        x: { align: "right", dx: -30 },
        y: { align: "top", dy: -20 }
    },

    pattern: {
        x: { align: "center" },
        y: { align: "center", dy: -140 }
    },

    fg: {
        width: 800,
        height: 966,
        position: {
            x: { align: "center" },
            y: { align: "top", dy: -365 }
        },

        top: {
            x: { align: "center" },
            y: { align: "top", dy: -20 },
            paddingX: 50,
            height: 70
        }
    },

    fgBottom: {
        x: { align: "center" },
        y: { align: "bottom", dy: 54 }
    },

    progressBar: {
        x: { align: "center" },
        y: { align: "top", dy: -270 }
    },

    stagesList: {
        width: 800,

        margin: 20,
        padding: {
            top: 0,
            bottom: 0
        }
    },

    stageRow: {
        margin: 0,
        padding: {
            left: 0,
            right: 0
        },

        circle: {
            line: {
                width: 27,
                height: 180,
                x: { align: "center" },
                y: { align: "center", dy: 90 }
            }
        },

        card: {
            width: 320,
            height: 178,

            icon: {
                x: { align: "center", dx: 10 },
                y: { align: "center" },
                width: 270,
                height: 98
            },

            lock: {
                x: { align: "right", dx: 18 },
                y: { align: "bottom", dy: -20 }
            }
        }
    },

    timer: {
        width: 260,
        x: { align: "center" },
        y: { align: "bottom", dy: -5 }
    },

    decoration: {
        crystals: {
            left: {
                x: { align: "left", dx: -25 },
                y: { align: "bottom", dy: -30 }
            },

            right: {
                x: { align: "right", dx: 25 },
                y: { align: "bottom", dy: -30 }
            }
        },

        flashlight: {
            left: {
                x: { align: "left", dx: 40 },
                y: { align: "center", dy: -105 }
            },

            right: {
                x: { align: "right", dx: -40 },
                y: { align: "center", dy: -105 }
            }
        }
    },

    headPicture: {
        x: { align: "center" },
        y: { align: "top", dy: 5 }
    },

    windowComponent: {
        progressBar: {
            width: 585,
            scale: 1,
            progress: bundles.levelmastery_window.frames.progress_bar_progress_png,
            background: bundles.levelmastery_window.frames.progress_bar_bg_png,
            barText: {
                dy: 2,
                font: cleverapps.styles.FONTS.LEVELMASTERY_WINDOW_PROGRESSBAR_TEXT
            }
        },

        cupIcon: {
            x: { align: "left", dx: -40 },
            y: { align: "center" }
        },

        reward: {
            x: { align: "right", dx: 40 },
            y: { align: "center" }
        }
    },

    helpButton: {
        x: { align: "left" },
        y: { align: "top", dy: -15 }
    }
};